import { type Product, type RemoteActionsMetas } from '../../common/types';

export const REMOTE_ACTIONS_KEY = 'atlassian-remote-actions';

export const readRemoteActionsMetasFromLocalStorage = (product: Product): RemoteActionsMetas => {
	try {
		return JSON.parse(localStorage.getItem(`${REMOTE_ACTIONS_KEY}.${product}`) || '{}');
	} catch (e) {
		console.warn('Could not load from localStorage', e);
		return {};
	}
};

export const writeRemoteActionsMetasToLocalStorage = (
	product: Product,
	remoteActionsMetas: RemoteActionsMetas,
) => {
	try {
		localStorage.setItem(`${REMOTE_ACTIONS_KEY}.${product}`, JSON.stringify(remoteActionsMetas));
	} catch (e) {
		console.warn('Could not load from localStorage', e);
	}
};
